import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=28e7cd0f&"
import script from "./CampaignOverview.vue?vue&type=script&lang=ts&"
export * from "./CampaignOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports